(ns quuppa.qsm.metadata.events
  (:require [re-frame.core :as rf :refer [reg-event-fx]]))

(reg-event-fx
  :metadata/save-metadata
  (fn [_ [_ qpe-identity metadata]]
    (when metadata
      {:fx [[:server-dispatch {:event      [:metadata/save-metadata {:qpe_identity qpe-identity
                                                                     :metadata     metadata}]
                               :on-success [::metadata-saved qpe-identity]
                               :on-error   [::metadata-save-failed qpe-identity]}]]})))

(rf/reg-event-db ::metadata-saved
  (fn [db [_ qpe-identity]]
    (update-in db [:qpes qpe-identity :ui] dissoc :sidebar)))

(rf/reg-event-db ::metadata-save-failed
  (fn [db [_ qpe-identity error]]
    (assoc-in db [:qpes qpe-identity :ui :sidebar :error] error)))
